import {
  MdOutlineEmail,
  MdOutlineVerifiedUser,
  MdBlock,
  MdOutlineLocalPhone,
} from 'react-icons/md';
import { BsGenderAmbiguous, BsEye } from 'react-icons/bs';
import { AiOutlineCrown } from 'react-icons/ai';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { HiOutlineIdentification } from 'react-icons/hi';
import { Chip } from '@wajeez-web/components/ui';
import { Identity, Payment } from '@wajeez-web/core/api-base';
import { GiToken } from 'react-icons/gi';
const UserViewDetails = ({
  data,
  points,
  fcmToken,
  userPlan,
}: {
  data: Identity.UserDetailsOutput;
  points: number;
  fcmToken: string | undefined;
  userPlan?: Payment.CustomerPlanOutput;
}) => {
  return (
    <div className=" space-y-5 divide-y px-8 ">
      <div className=" space-y-5">
        <div className=" text-3xl font-bold truncate">
          {data.name?.trim() || '{NO_Name}'}
        </div>
        {userPlan && (
          <div className="flex space-s-2">
            <Chip text={userPlan.planName || ''} />
            <Chip text={userPlan.name || ''} />
          </div>
        )}
      </div>
      <div className=" space-y-8 pt-5  ">
        <div className="flex sm:items-center space-s-6">
          <div>
            <HiOutlineIdentification className="h-6 w-6" />
          </div>
          <div className=" text-base">{data.id || '-'}</div>
        </div>
        <div className="flex sm:items-center space-s-6">
          <div>
            <MdOutlineEmail className="h-6 w-6" />
          </div>
          <div className=" text-base">{data.email || '-'}</div>
        </div>
        <div className="flex sm:items-center space-s-6">
          <div>
            <MdOutlineLocalPhone className="h-6 w-6" />
          </div>
          <div className=" text-base">{data.phoneNumber || '-'}</div>
        </div>
        <div className="flex sm:items-center space-s-6">
          <div>
            <GiToken className="h-6 w-6" />
          </div>
          <div className=" text-base">{fcmToken || '-'}</div>
        </div>
        <div className="flex sm:items-center space-s-6">
          <div>
            <BsGenderAmbiguous className="h-6 w-6" />
          </div>
          <div className=" text-base text-center">
            {(data.gender && Identity.Gender[data.gender]) || '-'}
          </div>
        </div>
        <div className="flex sm:items-center space-s-6">
          <div>
            <BsEye className="h-6 w-6" />
          </div>
          <div className=" text-base text-center">
            {data.lastLoginDate || '-'}
          </div>
        </div>
        <div className="flex sm:items-center space-s-6">
          <div>
            <MdBlock className="h-6 w-6" />
          </div>
          <div className=" text-base text-center">
            {data.isBlocked ? (
              <ReturnTranslatedText
                origintext="Blocked"
                text={`Slider.content.${'Blocked'}`}
              />
            ) : (
              <ReturnTranslatedText
                origintext="Not Blocked"
                text={`Slider.content.${'Not Blocked'}`}
              />
            )}
          </div>
        </div>
        <div className="flex sm:items-center space-s-6">
          <div>
            <MdOutlineVerifiedUser className="h-6 w-6" />
          </div>
          <div className=" text-base text-center">
            {data.isVerified ? (
              <ReturnTranslatedText
                origintext="Verified"
                text={`Slider.content.${'Verified'}`}
              />
            ) : (
              <ReturnTranslatedText
                origintext="Not Verified"
                text={`Slider.content.${'Not Verified'}`}
              />
            )}
          </div>
        </div>
        <div className="flex sm:items-center space-s-6">
          <div>
            <AiOutlineCrown className="h-6 w-6" />
          </div>
          <div className=" text-base text-center">
            {points || 0}{' '}
            {points === 1 ? (
              <ReturnTranslatedText
                origintext="Point"
                text={`Slider.content.${'Point'}`}
              />
            ) : (
              <ReturnTranslatedText
                origintext="Points"
                text={`Slider.content.${'Points'}`}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserViewDetails;
